/**
 * Scroll-reveal gradient for text modules (.text-module--gradient).
 *
 * The text carries a two-tone gradient (bright red above a soft boundary,
 * dark red below, background-size 100% 200%). While the module scrolls
 * through the viewport the boundary is swept from the first line to the
 * last, so the text "lights up" in reading order.
 *
 * @return {void}
 */
export default function InitGradientScroll() {
    const elements = document.querySelectorAll('.text-module--gradient .text-module__text');
    if (!elements.length) return;

    let ticking = false;

    const update = () => {
        const vh = window.innerHeight;

        elements.forEach(function (el) {
            const rect = el.getBoundingClientRect();
            // 0 → module entering the viewport, 1 → fully "read"
            const progress = Math.min(1, Math.max(0,
                (vh * 0.85 - rect.top) / (rect.height + vh * 0.35)
            ));
            // boundary travels top → bottom as progress grows
            el.style.backgroundPositionY = ((1 - progress) * 100) + '%';
        });
        ticking = false;
    };

    const requestUpdate = () => {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
}
